import { Component,Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { UploadApi } from '@assets/js/lb-sdk/services/custom/Upload';
import { BasicList } from '@app/classes';
import { UPLOAD_TYPE, UPLOAD_STATUS } from '@app/enums';
import { UploadFormComponent } from './upload-form/upload-form.component';
import { Event } from '@app/interfaces';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-payment-list-upload',
  templateUrl: './payment-list-upload.component.html',
  styleUrls: ['./payment-list-upload.component.css']
})
export class PaymentListUploadComponent extends BasicList {
  @Input() uploadType: UPLOAD_TYPE;

  UPLOAD_STATUS: typeof UPLOAD_STATUS = UPLOAD_STATUS;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'name', placeholder: 'ID/Name', wildcard: true },
      { name: 'status', placeholder: 'File Status', options: UPLOAD_STATUS },
      { name: 'error', placeholder: 'Processing Status', optionsFunction: () => {
        return [
          { value: '--null--', description: 'PROCESSED' },
          { value: { neq: null }, description: 'HAS ERROR' }
        ]
      } }
    ],
    filters: {}
  };

  constructor(
    public uploadApi: UploadApi,
    private modalService: BsModalService,
    private toast: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        type: this.uploadType
      },
      include: 'user',
      order: 'uploadDate DESC'
    };
    this.settings = {
      createComponent: UploadFormComponent,
      api: this.uploadApi,
      ModalService: this.modalService
    };
    this.emitEventInit();
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('File successfully uploaded for processing', 'Upload');
      case 'initialized':
        this.getList();
      break;
    }
  }
}
